import { ButtonText } from '@/components/common/Button'
import { CardArtFrame } from '@/components/common/Card'
import { SectionLabel } from '@/components/common/SectionLabel'
import { Icon } from '@/components/icons/Icon'
import { usePage } from '@/components/providers/PageProvider'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { formatFullNumber } from '@/utils/formatUtil'
import { getFilterCount } from '@/utils/routeUtil'

import styles from './FiltersPanelHeader.module.scss'
import { FiltersPanelHeaderDropdown } from './FiltersPanelHeaderDropdown/FiltersPanelHeaderDropdown'

export const FiltersPanelHeader = () => {
  const { buildRelative } = useLinkInternal()
  const { page } = usePage()
  const rec = page?.featured?.rec

  const hasRec = !!rec
  const route = page?.route
  const title = page?.metadata?.title || 'Page'
  const icon = page?.metadata?.icon || 'cards'
  const label = page?.metadata?.label

  const imageElement = hasRec ? (
    <CardArtFrame rec={rec} />
  ) : (
    <div className={styles.icon}>
      <Icon name={icon} />
    </div>
  )

  const filtersCount = getFilterCount(route)

  return (
    <div className={styles.container}>
      <div className={styles.image}>{imageElement}</div>
      <div className={styles.info}>
        <div className={styles.infoTop}>
          {label && <SectionLabel label={label} size='sm' />}
          <FiltersPanelHeaderDropdown />
          {filtersCount > 0 && (
            <div className={styles.buttonClear}>
              <ButtonText
                aria-label='Clear All Filters'
                as='LinkRoute'
                hover='warning'
                href={buildRelative({}, { clearOptionalFilters: true })}
                size='sm'
                title='Clear All Filters'
              >
                <Icon name='rotateLeft' />
              </ButtonText>
            </div>
          )}
        </div>
        <p className={styles.title}>{title}</p>
        {rec?.numDecks !== undefined && (
          <p className={styles.total}>
            {`${formatFullNumber(rec.numDecks)} ${filtersCount > 0 ? 'filtered' : 'total'} decks`}
          </p>
        )}
      </div>
    </div>
  )
}
